import { create } from "zustand";

export const useAppStore = create((set) => ({
  // Active reward animation
  reward: null,
  showReward: (reward) => set({ reward }),
  clearReward: () => set({ reward: null }),

  // Cookie consent
  cookiesAccepted: localStorage.getItem("cookies") === "true",
  acceptCookies: () => { localStorage.setItem("cookies", "true"); set({ cookiesAccepted: true }); },

  // Global loading overlay
  loading: false,
  setLoading: (loading) => set({ loading }),

  // Notification drawer
  notifDrawerOpen: false,
  toggleNotifDrawer: () => set((s) => ({ notifDrawerOpen: !s.notifDrawerOpen })),

  // Unread notification count
  unreadCount: 0,
  setUnreadCount: (n) => set({ unreadCount: n }),
}));
